import {addEventActivity, deleteEventActivity, updateEventActivity} from "../Activities/BrowserDatabaseFunctions";


export const E_addEventActivityResults = async (_incoming) => {
    console.log("E_addNewActivityResults : ", _incoming);

    try {
        if (_incoming?.result !== "ok") {
            console.log("Add result not ok");
            return null;
        }

        const eventId = _incoming.event_id;
        const newActivity = _incoming.activity; // should already contain { id, temp_id?, ... }

        if (!eventId || !newActivity) {
            console.error("Missing event_id or activity in payload");
            return null;
        }

        // Persist to browser DB (best-effort)
        try {
            await addEventActivity(eventId, newActivity);
            console.log("Activity added successfully");
        } catch (error) {
            console.error("Error adding Activity to Browser database: ", error);
        }

        return null;

    } catch (e) {
        console.log("ERROR:", e);
        return null;
    }
};

export const E_updateEventActivityResults = async (_incoming) => {
    console.log("E_updateEventActivityResults");

    /*
        an Event Activity was updated
     */

    try {
        const _result = _incoming.result;

        if (_result === "ok") {
            try {
                await updateEventActivity(_incoming.event_id, _incoming.activity);
                console.log("Activity updated successfully");
            } catch (error) {
                console.error("Error updating Activity: ", error);
            }

            return null; // Return the updated activity regardless of success or failure

        } else {
            console.log("Update result not ok");
            return null; // Return null if the result is not ok
        }

    } catch (e) {
        console.log("ERROROROR : " + e);
        return null; // Return null if there was a top-level error
    }
}

export const E_deleteEventActivityResults = async (_incoming) => {
    console.log("E_deleteEventActivityResults");

    /*
        an Event Activity was deleted
     */


    try {

        const _result = _incoming.result;

        if (_result === "ok") {

            try {
                await deleteEventActivity(_incoming.event_id, _incoming.activity_id);
                console.log("Activity deleted successfully");
            } catch (error) {
                console.error("Error deleting Activity: ", error);
            }

        }
    } catch (e){
        console.log("ERROROROR : "+e);
    }

}